export default __webpack_public_path__ + "tab4_video_poster31c552.png";